import { dispatchAppEvent } from './helpers'
import { commonEvents } from './common_events'
import { i18n } from '@js/i18n'

const duration = 7000

export class EventDispatcher {
  static dispatchShowSnackbarEvent (config) {
    dispatchAppEvent(commonEvents.showSnackbarEvent, config)
  }

  static dispatchShowLoaderEvent () {
    dispatchAppEvent(commonEvents.showLoaderEvent)
  }

  static dispatchHideLoaderEvent () {
    dispatchAppEvent(commonEvents.hideLoaderEvent)
  }

  static dispatchShowErrorEvent (msg) {
    const config = {
      position: 'center',
      isInfinity: false,
      showButton: false,
      type: 'error',
      duration,
      msg
    }
    dispatchAppEvent(commonEvents.showSnackbarEvent, config)
  }

  static dispatchShowSuccessEvent (msg, customDuration = duration) {
    const config = {
      position: 'center',
      isInfinity: false,
      showButton: true,
      btnText: i18n.lbl_close(),
      type: 'success',
      duration: customDuration,
      msg
    }
    dispatchAppEvent(commonEvents.showSnackbarEvent, config)
  }
}



// WEBPACK FOOTER //
// ./src/js/events/event_dispatcher.js